export default __webpack_public_path__ + "static/media/edit-file-requests.1667be0c.svg";